import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { StatusIcon } from 'src/components/ui/status-icon/NoonReportStatusIcon.styles';
import { RobDateStatusEnum } from 'src/enums/bunkering/robDateStatusEnum';
import { MAX_BDN_COUNT } from '../bunker-rob-page/RobUtils';

export const RobDateStatusIcon = (dateStatus: RobDateStatusEnum) => {
    switch (dateStatus) {
        case RobDateStatusEnum.aolIncomplete:
            return (
                <StatusIcon className="status-icon status-missing">
                    <FontAwesomeIcon icon="exclamation-circle" title="AOL(s) incomplete" />
                </StatusIcon>
            );
        case RobDateStatusEnum.incomplete:
            return (
                <StatusIcon className="status-icon status-incomplete">
                    <FontAwesomeIcon icon="exclamation-circle" title="Incomplete" />
                </StatusIcon>
            );
        case RobDateStatusEnum.complete:
            return (
                <StatusIcon className="status-icon status-approved">
                    <FontAwesomeIcon icon="check-circle" title="Complete" />
                </StatusIcon>
            );
        case RobDateStatusEnum.noBunker:
            return (
                <StatusIcon className="status-icon status-saved">
                    <FontAwesomeIcon icon="exclamation-circle" title="No bunker on board" />
                </StatusIcon>
            );
        case RobDateStatusEnum.exceededBunkerRefLimit:
            return (
                <StatusIcon className="status-icon status-error">
                    <FontAwesomeIcon icon="exclamation-circle" title={`Exceeded concurrent BDN limit (max ${MAX_BDN_COUNT})`} />
                </StatusIcon>
            );
    }
};

export default RobDateStatusIcon;
